import HeaderImage from '../../assets/passport.jpg'
import data from './data'
import './header.css'

const Header = () => {
  return (
    <header id="header">
      <div className="container header__container">
        <div className="header__profile">
          <img src={HeaderImage} alt="Joseph Attard Fava portrait" width="288" height="432" />
        </div>
        <h1>Joseph Attard Fava</h1>
        <p>
          Senior Software Developer
        </p>
        <div className="header__cta">
          <a href="#resume" className='btn primary'>Resumé</a>
          <a href="#contact" className='btn light'>Let's Talk</a>
        </div>
        <div className="header__socials">
          {
            data.map(item=> <a key={item.id} href={item.link} target="_blank"
            rel="noopener noreferrer">{item.icon}</a>)
          }
        </div>
      </div>
      </header>
  )
}

export default Header